;(function () {
	// Store swiper instances in a WeakMap to avoid memory leaks
	const swiperInstances = new WeakMap()

	const initCardList = () => {
		document.querySelectorAll('.card-list-section').forEach((section) => {
			const texts = section.querySelectorAll('.card-list__text')
			const images = section.querySelectorAll('.card-list__item_img_active')
			const items = section.querySelectorAll('.card-list__item_active')

			if (items.length === 0) return

			const textAlwaysVisible = items[0].dataset.textAlwaysVisible === 'true'
			const isDesktop = window.matchMedia('(min-width: 990px)').matches

			if (textAlwaysVisible != true) {
				const setImageHeight = (image, textHeight, fullHeight) => {
					if (!image) return
					// Use calc() for absolutely positioned elements - 100% refers to positioned parent (item)
					image.style.height = fullHeight ? '100%' : `calc(100% - ${textHeight}px)`
				}

				texts.forEach((text, i) => {
					const image = images[i]
					const item = items[i]

					if (!item || !image) return

					// Skip if already initialized
					if (item.dataset.hoverInitialized === 'true') return

					// Wait for layout to calculate proper heights
					const initHeight = () => {
						// Force a reflow to ensure accurate measurements
						item.offsetHeight
						const textHeight = text.offsetHeight

						if (isDesktop) {
							setImageHeight(image, textHeight, true)

							const handleHover = (fullHeight) => {
								if (window.matchMedia('(min-width: 990px)').matches) {
									// Recalculate text height on hover in case it changed
									const currentTextHeight = text.offsetHeight
									setImageHeight(image, currentTextHeight, fullHeight)
								}
							}

							// Attach hover to link if it exists, otherwise to the item
							const link = item.querySelector('.card-list__item-link')
							const hoverTarget = link || item

							hoverTarget.addEventListener('mouseenter', () => handleHover(false))
							hoverTarget.addEventListener('mouseleave', () => handleHover(true))
							
							// Mark as initialized
							item.dataset.hoverInitialized = 'true'
						} else {
							setImageHeight(image, textHeight, false)
							item.dataset.hoverInitialized = 'true'
						}
					}

					// Use requestAnimationFrame to ensure layout is complete
					requestAnimationFrame(initHeight)
				})
			}
		})
	}

	const initSwipers = () => {
		document.querySelectorAll('.card-list-section').forEach((section) => {
			const id = section.id
			if (!id) return
			
			const box = section.querySelector('.card-list')
			if (!box) return
			
			const swiper = box.querySelector('.swiper')
			if (!swiper) return
			
			// Check if already initialized
			if (box.dataset.swiperInitialized === 'true') return
			
			const swipeOnMobile = box.dataset.swipeMobile === 'true' || box.getAttribute('data-swipe-mobile') === 'true'
			const swipeOnDesktop = box.dataset.swipeDesktop === 'true' || box.getAttribute('data-swipe-desktop') === 'true'
			const isMobile = window.innerWidth <= 576
			const isDesktop = window.innerWidth > 576
			
			// If swipe is disabled for current breakpoint, remove swiper classes and return
			if ((isMobile && !swipeOnMobile) || (isDesktop && !swipeOnDesktop)) {
				// Remove swiper classes to restore normal grid layout
				const listEl = box.querySelector('.card-list__list')
				if (listEl) {
					listEl.classList.remove('swiper-wrapper')
				}
				const slides = box.querySelectorAll('.swiper-slide')
				slides.forEach((slide) => {
					slide.classList.remove('swiper-slide')
				})
				return
			}
			
			const slideshowSpeed = parseInt(box.dataset.speed) || parseInt(box.getAttribute('data-speed')) || 0
			const delay = slideshowSpeed > 0 ? slideshowSpeed * 1000 : 4 * 1000

			let autoplayParm = {}
			if (slideshowSpeed > 0) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: true,
						disableOnInteraction: false,
					},
				}
			}

			// Get columns per row from data attribute
			const columnsPerRow = parseInt(box.dataset.columnsPerRow) || parseInt(box.getAttribute('data-columns-per-row')) || 3
			
			// Get mobile columns from class
			const listEl = box.querySelector('.card-list__list')
			const columnsMobile = listEl && listEl.classList.contains('columns_mobile--2') ? 2 : 1
			
			// Determine slides per view based on device and settings
			let baseSlidesPerView = 1
			let breakpointsConfig = {}
			
			if (isMobile && swipeOnMobile) {
				// Mobile: use columns_mobile setting
				baseSlidesPerView = columnsMobile
			} else if (isDesktop && swipeOnDesktop) {
				// Desktop: use columns per row setting
				baseSlidesPerView = columnsPerRow
				// Set breakpoint to ensure it works on resize
				breakpointsConfig = {
					576: {
						slidesPerView: columnsPerRow,
						spaceBetween: 16,
					},
				}
			}

			const swiperParms = {
				slidesPerView: baseSlidesPerView,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				loop: false,
				spaceBetween: 16,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
					type: 'bullets',
				},
				...(Object.keys(breakpointsConfig).length > 0 ? { breakpoints: breakpointsConfig } : {}),
				...autoplayParm,
			}

			const swiperInstance = new Swiper(`#${id} .swiper`, swiperParms)
			
			// Store instance in WeakMap
			swiperInstances.set(box, swiperInstance)
			
			// Force update after a brief delay to ensure container has correct width
			setTimeout(() => {
				if (isDesktop && swipeOnDesktop) {
					// Get the actual swiper container element
					const swiperEl = document.querySelector(`#${id} .swiper`)
					if (swiperEl) {
						// Force Swiper to recalculate sizes using updateSize
						swiperInstance.params.slidesPerView = columnsPerRow
						if (swiperInstance.breakpoints) {
							swiperInstance.breakpoints.update()
						}
						swiperInstance.updateSize()
						swiperInstance.update()
						swiperInstance.updateSlidesClasses()
						swiperInstance.updateSlides()
					}
				}
			}, 100)
			
			box.dataset.swiperInitialized = 'true'
		})
	}

	// Remove swiper classes if swipe is not enabled for current breakpoint
	const removeSwiperSlidesIfNeeded = () => {
		document.querySelectorAll('.card-list-section').forEach((section) => {
			const box = section.querySelector('.card-list')
			if (!box) return
			
			const swipeOnMobile = box.dataset.swipeMobile === 'true' || box.getAttribute('data-swipe-mobile') === 'true'
			const swipeOnDesktop = box.dataset.swipeDesktop === 'true' || box.getAttribute('data-swipe-desktop') === 'true'
			const isMobile = window.innerWidth <= 576
			const isDesktop = window.innerWidth > 576
			
			// Remove swiper classes if swipe is disabled for current breakpoint
			if ((isMobile && !swipeOnMobile) || (isDesktop && !swipeOnDesktop)) {
				const listEl = box.querySelector('.card-list__list')
				if (listEl) {
					listEl.classList.remove('swiper-wrapper')
				}
				const slides = box.querySelectorAll('.swiper-slide')
				slides.forEach((slide) => {
					slide.classList.remove('swiper-slide')
				})
			}
		})
	}

	const destroySwipers = () => {
		document.querySelectorAll('.card-list-section').forEach((section) => {
			const box = section.querySelector('.card-list')
			if (!box) return
			
			const instance = swiperInstances.get(box)
			if (instance && typeof instance.destroy === 'function') {
				instance.destroy(true, true)
				swiperInstances.delete(box)
			}
			box.dataset.swiperInitialized = 'false'
		})
	}

	const init = () => {
		removeSwiperSlidesIfNeeded()
		initCardList()
		initSwipers()
	}

	document.addEventListener('DOMContentLoaded', function () {
		init()
	})

	document.addEventListener('shopify:section:load', function (event) {
		// Reset initialization flags when section reloads
		const section = event.detail?.sectionId ? document.getElementById('shopify-section-' + event.detail.sectionId) : event.target
		if (section && section.classList.contains('card-list-section')) {
			const items = section.querySelectorAll('.card-list__item_active')
			items.forEach(item => {
				item.dataset.hoverInitialized = 'false'
			})
			const box = section.querySelector('.card-list')
			if (box) {
				const instance = swiperInstances.get(box)
				if (instance && typeof instance.destroy === 'function') {
					instance.destroy(true, true)
					swiperInstances.delete(box)
				}
				box.dataset.swiperInitialized = 'false'
			}
		}
		init()
	})

	window.addEventListener('resize', function () {
		// Reinitialize swipers on resize to handle breakpoint changes
		destroySwipers()
		document.querySelectorAll('.card-list-section').forEach((section) => {
			const items = section.querySelectorAll('.card-list__item_active')
			items.forEach(item => {
				item.dataset.hoverInitialized = 'false'
			})
		})
		init()
	})
})()

